import {
  LOGOUT,
  PROFILE_FETCH,
  CURRENT_LOCATION,
  PROFILE_SAVE,
  DRIVER_STATUS,
  PROFILE_IMAGE,
  GOOGLE_MAPS_LOADED,
  CAR_REGISTER_CHECK,
  CAR_REGISTER_CHECK_NULL,
  REFRESH_ZONE,
  LAST_BOOKING_ZONE_ID,
  EMERGENCY_DETAILS,
  GET_EMERGENCY_DETAILS,
  DELETE_EMERGENCY_DETAILS,
  FETCH_TRIPS_COUNT,
  CUSTOMER_MIGRATE,
  IMAGE_PROCESS,
  DRIVER_PROFILE_UPDATE,
  VEHICLE_LIST,
  VEHICLE_GET_DETAILS,
  VEHICLE_DETAILS_UPDATE,
  VEHICLE_DETAILS_SAVE,
  FETCH_DRIVER_DETAILS,
  UPLOAD_DRIVER_IMAGES,
  DRIVER_FILES,
  UPLOAD_VEHICLE_FILES,
  VEHICLE_FILES,
  CLEAR_VEHICLE_DETAILS,
  ACCEPT_VEHICLE_SHARING,
  SHARE_VEHICLE,
  CANCEL_VEHICLE,
  SHARE_NOTIFICATIONS,
  ABORT_SHARE,
  DRIVER_APPROVAL,
  VEHICLE_APPROVAL,
  CHECK_DRIVER_VALIDATION,
  SUBSCRIBE_VEHICLE,
  UNSUBSCRIBE_VEHICLE,
  TERMINATE_VEHICLE,
} from 'App/store/constants';
import { MakeApiRequest } from 'App/common/Http';
import store from 'App/store/store';


export const logoutSubmit = () => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/logout',
    method: 'POST',
    data: {},
    nextActionType: LOGOUT,
  });
};
export const deleteAccount = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/delete-account',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: LOGOUT,
  });
};
export const refreshZone = (zoneId: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: `zones/fetch/zone/${zoneId}`,
    method: 'GET',
    nextActionType: REFRESH_ZONE,
  });
};

export const emergencySave = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `emergency/save/me`,
    method: 'POST',
    data: data,
    errorMsg: true,
    successMsg: true,
    nextActionType: EMERGENCY_DETAILS,
  });
};

export const getEmergencyDetails = () => {
  return MakeApiRequest({
    server: 'login',
    url: `emergency/list/me`,
    method: 'GET',
    nextActionType: GET_EMERGENCY_DETAILS,
  });
};

export const deleteEmergencyDetails = (id: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `emergency/${id}`,
    method: 'DELETE',
    errorMsg: true,
    successMsg: true,
    nextActionType: DELETE_EMERGENCY_DETAILS,
  });
};

export const customerMigrate = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `customers/migrate/to/${data}`,
    method: 'GET',
    successMsg: true,
    errorMsg: true,
    nextActionType: CUSTOMER_MIGRATE,
  });
};

export const fetchLastRideZone = () => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/fetchlast/ride',
    method: 'GET',
    nextActionType: LAST_BOOKING_ZONE_ID,
  });
};

export const setCurrentLocation = (data: any) => ({
  type: CURRENT_LOCATION,
  payload: data,
});

export const setGoogleMapLoaded = (data: any) => {
  return { type: GOOGLE_MAPS_LOADED, payload: data };
  // return (dispatch: any, data: any) => {

  // dispatch({type: GOOGLE_MAPS_LOADED, payload: data}); 
  // };
};

export const updateDriverStatus = (url: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `cust/driver_status/${url}`,
    method: 'GET',
    nextActionType: DRIVER_STATUS,
  });
};

export const profileFetch = (url: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `cust/${url}`,
    method: 'GET',
    nextActionType: PROFILE_FETCH,
  });
};
export const fetchTripsCount = () => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'bookings/trips-count',
    method: 'GET',
    nextActionType: FETCH_TRIPS_COUNT,
  });
};

export const profileSave = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/profile',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: PROFILE_SAVE,
  });
};

export const uploadProfileImage = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/upload',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-type': 'multipart/form-data' },
    nextActionType: PROFILE_IMAGE,
  });
};



export const carRegistrationCheck = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'drivers/vehicle/check',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: CAR_REGISTER_CHECK,
  });
};

export const resetCarRegistrationData = () => ({
  type: CAR_REGISTER_CHECK_NULL,
});


export const uploadImageProcess = (data: any) => {
  return MakeApiRequest({
    server: 'taxi',
    url: 'image/process-image',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: IMAGE_PROCESS,
  });
};


//****************************DRIVER MANAGEMENT Vehicle************************ */

export const vehiclesList = () => {
  // Phase 5.4 — visible feedback when the vehicle list fetch fails.
  // Same rationale as fetchDriverDetails: silent failure left
  // MainPageDetails empty with no actionable signal.
  return MakeApiRequest({
    server: 'login',
    url: 'customer-driver/my-details',
    method: 'GET',
    errorMsg: true,
    nextActionType: VEHICLE_LIST,
  });
};
export const vehicleListById = (id: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `customer-driver/driver-vehicle/${id}`,
    method: 'GET',
    errorMsg: true,
    nextActionType: VEHICLE_GET_DETAILS,
  });
};
export const vehicleDeleteById = (id: any) => {
  // Phase 5.4 — destructive action, surface server errors. Toast on
  // success too so the user gets confirmation that the row really
  // went away (the screen typically navigates straight after).
  return MakeApiRequest({
    server: 'login',
    url: `customer-driver/driver-vehicle/${id}`,
    method: 'DELETE',
    successMsg: true,
    errorMsg: true,
    nextActionType: VEHICLE_GET_DETAILS,
  });
};

// Dispatches directly, mirroring how MakeApiRequest reaches the store. The
// screens' mapDispatchToProps is the no-arg factory form, so a returned action
// object would never be dispatched by anyone.
export const clearVehicleDetails = () => store.dispatch({
  type: CLEAR_VEHICLE_DETAILS,
});

export const vehicleDetailsUpdate = (id: any, data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `customer-driver/driver-vehicle/${id}`,
    method: 'PUT',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: VEHICLE_DETAILS_UPDATE,
  });
}
export const vehicleNewlyAdd = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'customer-driver/driver-vehicle',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: VEHICLE_DETAILS_SAVE,
  });
}
export const uploadVehicleImageFiles = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/licenseupload',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-type': 'multipart/form-data' },
    nextActionType: UPLOAD_VEHICLE_FILES,
  });
};
export const uploadVehicleFiles = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/licenseupload',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-type': 'multipart/form-data' },
    nextActionType: VEHICLE_FILES,
  });
};
export const checkDriverByMobile = (data: any) => {
  // QA recheck — was sharing the SHARE_VEHICLE action type with the
  // share-create call below, which meant `state.user.driver_check`
  // (the verified-driver row) got clobbered by the share-create
  // response envelope. Now uses its own CHECK_DRIVER_VALIDATION
  // type; the reducer maps SUCCESS to driver_check exclusively.
  return MakeApiRequest({
    server: 'login',
    url: 'vehicle-sharing/driver-details',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-Type': 'application/json' },
    nextActionType: CHECK_DRIVER_VALIDATION,
  });
};
export const shareVehicleToDriver = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'vehicle-sharing/share',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-Type': 'application/json' },
    nextActionType: SHARE_VEHICLE,
  });
};
export const cancelShareVehicle = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `vehicle-sharing/cancel-share`,
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-Type': 'application/json' },
    nextActionType: CANCEL_VEHICLE,
  });
}

export const shareNotifications = () => {
  // Phase 5.4 — surface server errors. The user explicitly opens this
  // screen and a silent fetch failure left the page perpetually empty
  // with no signal as to why.
  return MakeApiRequest({
    server: 'login',
    url: 'vehicle-sharing/notification-vehicle-share-list',
    method: 'GET',
    errorMsg: true,
    nextActionType: SHARE_NOTIFICATIONS,
  });
};

export const vehicleAcceptSharing = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'vehicle-sharing/accept-share',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: ACCEPT_VEHICLE_SHARING,
  });
}
export const abortShareVehicle = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `vehicle-sharing/abort-share`,
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-Type': 'application/json' },
    nextActionType: ABORT_SHARE,
  });
}
export const terminateVehicle = (data: any) => {
  // QA recheck — each lifecycle action now has its own action type
  // so the reducer can update the slice independently. Sharing
  // ABORT_SHARE across all three (terminate / subscribe /
  // unsubscribe) silently dropped the response payload because
  // ABORT_SHARE.SUCCESS only flips `loading: false`.
  return MakeApiRequest({
    server: 'login',
    url: `vehicle-sharing/terminate-share`,
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-Type': 'application/json' },
    nextActionType: TERMINATE_VEHICLE,
  });
}

export const subcribeVehicle = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `vehicle-sharing/subscribe-vehicle`,
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-Type': 'application/json' },
    nextActionType: SUBSCRIBE_VEHICLE,
  });
}
export const unsubcribeVehicle = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `vehicle-sharing/unsubscribe-vehicle`,
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-Type': 'application/json' },
    nextActionType: UNSUBSCRIBE_VEHICLE,
  });
}

//****************************DRIVER MANAGEMENT Driver************************ */
export const driverDetailsSave = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'customer-driver/driver-update',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    nextActionType: DRIVER_PROFILE_UPDATE,
  });
};

export const fetchDriverDetails = () => {
  // Phase 5.4 — surface server errors. The KYC screens silently
  // showed an empty list when this fetch failed; users now see a
  // toast and know to retry.
  return MakeApiRequest({
    server: 'login',
    url: 'customer-driver/driver-update',
    method: 'GET',
    errorMsg: true,
    nextActionType: FETCH_DRIVER_DETAILS,
  });
};


export const uploadDriverImageFile = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/upload',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-type': 'multipart/form-data' },
    nextActionType: UPLOAD_DRIVER_IMAGES,
  });
};
export const uploadDriverFile = (data: any) => {
  return MakeApiRequest({
    server: 'login',
    url: 'cust/licenseupload',
    method: 'POST',
    data: data,
    successMsg: true,
    errorMsg: true,
    headers: { 'Content-type': 'multipart/form-data' },
    nextActionType: DRIVER_FILES,
  });
};

export const setApprovalDriver = () => {
  return MakeApiRequest({
    server: 'login',
    url: `customer-driver/driver-kyc/submit`,
    method: 'GET',
    errorMsg: true,
    successMsg: true,
    nextActionType: DRIVER_APPROVAL,
  });
};

export const setApprovalVehicle = (id: any) => {
  return MakeApiRequest({
    server: 'login',
    url: `customer-driver/vehicle-kyc/submit/${id}`,
    method: 'GET',
    errorMsg: true,
    successMsg: true,
    nextActionType: VEHICLE_APPROVAL,
  });
};